import React from 'react';
import PropTypes from 'prop-types';
import { isPushApiStatusActive, isPushApiStatusTerminated } from 'modules/push-api/utils/subscriptionConsts';
import ToggleSwitchCellRenderer from '../ToggleSwitchCellRenderer';

export const PushApiStateCellRenderer = ({ value, data, isDisabled, ...rest }) => {
    const valueToToggled = () => isPushApiStatusActive(value);
    const isToggleDisabled = rowData => {
        return isPushApiStatusTerminated(rowData.status) || !rowData.accountId || rowData.accountId === '';
    };

    return (
        <ToggleSwitchCellRenderer
            {...rest}
            disabled={isDisabled(data) || isToggleDisabled(data)}
            valueToToggled={valueToToggled}
            defaultMessage="Subscription Status"
        />
    );
};
PushApiStateCellRenderer.propTypes = {
    ...ToggleSwitchCellRenderer.propTypes,
    isDisabled: PropTypes.func,
};

PushApiStateCellRenderer.defaultProps = {
    isDisabled: () => false,
};
